// decorators/materialize.ts
import { A } from "@adornis/base/env-info.js";
import { MongoEntity } from "@adornis/baseql/entities/mongoEntity.js";
import { baseqlMetaData } from "@adornis/baseql/metadata/metaDataStore.js";
import { isMainThread } from "node:worker_threads";
import { getStandardMaterializedCollectionName, registerNewView } from "../server/view-manager.js";
function Materialize(options) {
  return (TargetClass) => {
    if (!A.isServer)
      return;
    if (!isMainThread)
      return;
    if (!baseqlMetaData.entities.validSubclasses(MongoEntity._class).includes(TargetClass._class))
      throw new Error(
        "Cannot create materilized view for class " + TargetClass._class + ". Make sure its a MongoEntity and registered in the metaDataTree"
      );
    const collectionName = options?.materializedCollectionName ?? getStandardMaterializedCollectionName(TargetClass);
    const selectionSet = options.selectionSet;
    registerNewView({
      targetClass: TargetClass,
      collectionName,
      selectionSet,
      selectionSetHash: ""
    });
  };
}
export {
  Materialize
};
